import React from 'react';
import { ReactQueryProvider } from '@/utils/ReactQuery';
import LiveSessionForensics from './LiveSessionForensics';

interface Props {
  aiSummaryEnabled?: boolean;
  sessionId: string;
}

const LiveSessionForensicsEntry = ({ aiSummaryEnabled = false, sessionId }: Props) => (
  <ReactQueryProvider>
    <LiveSessionForensics aiSummaryEnabled={aiSummaryEnabled} sessionId={sessionId} />
  </ReactQueryProvider>
);

export default LiveSessionForensicsEntry;
